import React, { useEffect, useState, useRef } from 'react';


import imgBtn from '@/assets/images/btn/btn.png';
import imgBtnDisabled from '@/assets/images/btn/btn-disabled.png';
import imgLabelGet from '@/assets/images/btn/labelGet.png';
import imgLabelHelp from '@/assets/images/btn/labelHelp.png';
import imgLabelOver from '@/assets/images/btn/labelOver.png';

import styles from './index.less';

const Btn=(props)=>{
  const {disabled=false,className='',label='',onClick=()=>{}} = props;
  const imgLabel={
    'get':imgLabelGet,
    'help':imgLabelHelp,
    'over':imgLabelOver
  }
  return (
    <section className={`${styles.wrap} ${className}`} onClick={onClick}>
      <img className={styles.bg} src={disabled?imgBtnDisabled:imgBtn} />
      {
        imgLabel[label]? <img className={styles.imgLabel} src={imgLabel[label]} />:<span className={styles.label}>{label}</span>
      }
    </section>
  )
}

export default Btn;